// extracted by mini-css-extract-plugin
export default {"msgM":"_80165944e5"};